import axios from '@/api/axios'
import { VersionModel } from './models/VersionModel'

class MaintenanceService {
  async getVersion(): Promise<VersionModel> {
    const res = await axios.get(`/maintenance/version`)
    return res.data
  }
}

export default new MaintenanceService()
